<template>
	<td>
		<edit-btn
			v-if="editBtn"
			@click="$emit('edit',item)"
		/>
		<remove-btn
			:loading="removeProgress"
			@remove="removeItem"
		/>
		<slot />
	</td>
</template>

<script>
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";

	export default {
		name: "action-td",
		components: { RemoveBtn, EditBtn },
		props: { item: Object, module: String, editBtn: { default: true, type: Boolean } },
		data () {
			return {
				removeProgress: false,
			};
		},
		methods: {
			async removeItem () {
				this.removeProgress = true;
				if (this.module) {
					await this.$store.dispatch(this.module + "/remove", this.item);
					this.removeProgress = false;
				}
				this.$emit("remove", this.item);
			},
		},
	};
</script>

<style scoped>

</style>
